export const getAuthProvider = (user = null) => {
  if (!user) return null

  const provider = user.identities?.[0]?.providerName ||
    user.provider ||
    user.identity?.provider ||
    user.account?.provider ||
    user.claims?.provider ||
    user.profile?.provider ||
    user.identity_provider ||
    user.idp ||
    null

  return provider ? String(provider).toUpperCase() : null
}

const getBaseUrl = () => {
  return process.env.VUE_APP_SAS_VIYA4_PROD_DOMAIN
  }

  export const oidcSettings = {
    authority: getBaseUrl() + '/SASLogon/',
    clientId: 'product_analytics_app',
    client_secret: 'kCiP12Ruux0paVkTiqFe',
    redirectUri:  window.location.origin + '/callback',
    responseType: 'code',
    scope: 'openid',
    client_authentication: 'client_secret_basic',
    metadata: {
      issuer: getBaseUrl() + '/SASLogon/oauth/token',
      userinfo_endpoint: getBaseUrl() + "/SASLogon/userinfo",
      end_session_endpoint: getBaseUrl() + '/SASLogon/logout.do?',
      authorization_endpoint: getBaseUrl() + '/SASLogon/oauth/authorize',
      token_endpoint: getBaseUrl() + '/SASLogon/oauth/token?',
      jwks_uri: getBaseUrl() + '/SASLogon/token_keys'
    }
  }
  const getBaseUrlTest = () => {
    return process.env.VUE_APP_SAS_VIYA4_TEST_DOMAIN
    }

  export const oidcSettingsTest = {
    authority: getBaseUrlTest() + '/SASLogon/',
    clientId: 'product_analytics_app',
    client_secret: 'kCiP12Ruux0paVkTiqFe',
    redirectUri:  window.location.origin + '/callback',
    responseType: 'code',
    scope: 'openid',
    client_authentication: 'client_secret_basic',
    metadata: {
      issuer: getBaseUrlTest() + '/SASLogon/oauth/token',
      userinfo_endpoint: getBaseUrlTest() + "/SASLogon/userinfo",
      end_session_endpoint: getBaseUrlTest() + '/SASLogon/logout.do?',
      authorization_endpoint: getBaseUrlTest() + '/SASLogon/oauth/authorize',
      token_endpoint: getBaseUrlTest() + '/SASLogon/oauth/token?',
      jwks_uri: getBaseUrlTest() + '/SASLogon/token_keys'
    }
  }

 
export const oidcSettingsDev = {
  authority: 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_MVmJVbkkI',
  clientId: '515bavjr04m1j9ijs9tme5ogin',
  redirectUri: window.location.origin + '/callback',
  postLogoutRedirectUri: window.location.origin,
  responseType: 'code',
  scope: 'openid email profile',
  loadUserInfo: true,
  metadata: {
    issuer: 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_MVmJVbkkI',
    authorization_endpoint: 'https://auth.collaboration-layer.com/oauth2/authorize',
    token_endpoint: 'https://auth.collaboration-layer.com/oauth2/token',
    userinfo_endpoint: 'https://auth.collaboration-layer.com/oauth2/userInfo',
    end_session_endpoint: 'https://auth.collaboration-layer.com/logout',
    revocation_endpoint: 'https://auth.collaboration-layer.com/oauth2/revoke',
    jwks_uri:
      'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_MVmJVbkkI/.well-known/jwks.json'
  }
}
  
